<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Link({
              label: 'Link',
              modelPath: [this, 'form', 'button_link'],
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
